import { useMutation } from '@tanstack/react-query';
import { RestEndpoints } from "../../../../../api/endpoints";
import getInstance from "../../../../../utils/rest";

const getOrderDeliveryReport = async (orderIds: number[]): Promise<string> => {
  const { data } = await getInstance().post<string>(RestEndpoints.CfmOrderXDeliveryReport, {
    ids: orderIds,
  });

  return data;
};

export const useGetOrderXDeliveryReport = (orderIds: number[]) => {
  return useMutation({
    mutationFn: () => getOrderDeliveryReport(orderIds)
  });
};
